import { Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-dialog-close-overlay',
    standalone: true,
    imports: [MatIconModule, MatButtonModule],
    template: `
    <button mat-icon-button type="button" (click)="close.emit()" aria-label="Close top dialog">
      <mat-icon>close</mat-icon>
    </button>
  `,
    styles: [`
    :host {
      position: absolute;
      top: 12px;
      right: 64px;
      z-index: 2000;
    }

    button {
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.12);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      border-radius: 50%;
    }
  `]
})
export class DialogCloseOverlayComponent {
    @Output() close = new EventEmitter<void>();
}
